import { Component } from 'react';
import PropTypes from 'prop-types';
import BackToTopLink from './presentionalComponents/BackToTopLink';
import BackToTopButton from './presentionalComponents/BackToTopButton';
import uiLocale from '../../translations/UILocale';

export default class BackToTop extends Component {

  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleResize = this.handleResize.bind(this);

    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    if (!this.props.isDesktop) {
      window.addEventListener('scroll', this.handleScroll);
      const ua = window.navigator.userAgent;
      if (ua.includes('iPhone') && ua.includes('Safari')) {
        window.addEventListener('resize', this.handleResize);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }

  // hide or show the button on touch devices
  handleScroll() {
    this.setState({ visible: window.pageYOffset > 20 });
  }

  handleClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // handle popping up addressbar in safari on iPhones
  handleResize() {
    const bodyHeight = document.documentElement.clientHeight;
    const windowHeight = window.innerHeight;
    const isLandscape = Math.abs(window.orientation) === 90;
    const moveButton = (windowHeight < bodyHeight);

    if (isLandscape) {
      const bTTElement = document.querySelector('[class*="BackToTopButton"]');
      bTTElement.style.bottom = moveButton ? '70px' : '20px';
    }
  }

  render() {
    const { isDesktop } = this.props;

    return (
      <>
        {isDesktop
          ? (
            <BackToTopLink
              handleClick={this.handleClick}
              label={uiLocale.getString('component.productlisting.backToTopButton')}
            />
          )
          : (
            <BackToTopButton
              handleClick={this.handleClick}
              isVisible={this.state.visible}
            />
          )}
      </>
    );
  }

}

BackToTop.defaultName = 'BackToTop';

BackToTop.propTypes = {
  isDesktop: PropTypes.bool
};

BackToTop.defaultProps = {
  isDesktop: true
};
